import { createReducer } from '@reduxjs/toolkit';
import { setCategoryCollection, setCategoryCollectionLoading, setCategoryRecords } from './actions';
import type { CategoryDataModel } from './types';

const DEFAULT_COLLECTION_STATE = {
    identifiers: [],
    isLoading: false,
};

interface CategoriesState {
    records: Record<string, CategoryDataModel>;
    collections: Record<
        string,
        {
            identifiers: Array<CategoryDataModel['id']>;
            isLoading: boolean;
        }
    >;
}

export const categoriesReducer = createReducer<CategoriesState>(
    {
        records: {},
        collections: {},
    },
    (builder) => {
        builder
            .addCase(setCategoryRecords, (draft, action) => {
                action.payload.forEach((category) => {
                    draft.records[category.id] = category;
                });
            })

            .addCase(setCategoryCollection, (draft, action) => {
                const { namespace, identifiers } = action.payload;

                draft.collections[namespace] = draft.collections[namespace] ?? {
                    ...DEFAULT_COLLECTION_STATE,
                };

                draft.collections[namespace].identifiers.push(...identifiers);
            })

            .addCase(setCategoryCollectionLoading, (draft, action) => {
                const { namespace, isLoading } = action.payload;

                draft.collections[namespace] = draft.collections[namespace] ?? {
                    ...DEFAULT_COLLECTION_STATE,
                };

                draft.collections[namespace].isLoading = isLoading;
            });
    },
);
